module.exports = __webpack_public_path__ + "static/image/service/pc/visual.jpg?945ecc1c";